import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import { useAuth } from '../context/AuthContext';

/**
 * Component that identifies users in PostHog when they are authenticated.
 * Sets the person's name and other user properties in PostHog.
 */
const PostHogIdentity: React.FC = () => {
  const posthog = usePostHog();
  const { user } = useAuth();

  useEffect(() => {
    // Only identify if both PostHog and user are available
    if (!posthog || !user) {
      return;
    }

    // Identify the user with their ID and set properties
    posthog.identify(
      user.id.toString(), // distinct_id - use user ID as unique identifier
      {
        name: user.name,
        email: user.email,
        role: user.role,
        // Include other relevant user properties
        ...(user.google_id && { google_id: user.google_id }),
        ...(user.picture_url && { picture_url: user.picture_url }),
        ...(user.tennisrecord_name && { tennisrecord_name: user.tennisrecord_name }),
        ...(user.created_at && { created_at: user.created_at }),
        ...(user.last_login && { last_login: user.last_login }),
      }
    );
  }, [posthog, user]);

  // This component doesn't render anything
  return null;
};

export default PostHogIdentity;

